import React, {
    useEffect,
    useRef,
    useState,
    useReducer,
    useCallback,
    useMemo,
} from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Divider,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Link,
  Tooltip,
  Modal,        // <-- add
  IconButton,   // <-- add
  InputLabel,   // <-- add
  TextField,    // <-- add
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CancelTwoToneIcon from "@mui/icons-material/CancelTwoTone";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import SignaturePad from "react-signature-canvas";
import Swal from "sweetalert2";
import moment from "moment";
import EditIcon from "@mui/icons-material/Edit";                  // for edit signature button
// import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline"; // if you use this too
import SignatureCanvas from "react-signature-canvas";             // for signature input


import {
    sectionsReducer,
    initialSections,
    toApiPayload,
    fromApiPayload,
    ACTIONS,
} from "./dualListEngine";
import ObgyngenericAccordion from "./ObgyngenericAccordion";

// Preset options
const PRESET_OPTIONS = {
    constitutional: [
        "Fever",
        "Chills",
        "Rigors",
        "Night Sweats",
        "Fatigue",
        "Weight Loss",
        "Weight Gain",
        "Decreased Energy",
    ],
    integumentary: [
        "Itching",
        "Discoloration",
        "Papules",
        "Pustules",
        "Cysts",
        "Nodules",
        "Scars",
        "Hair Loss",
        "Scaly Skin",
        "Vesicles",
        "Blisters",
        "Dry Skin",
        "Bumps",
        "Lumps",
        "Rash",
    ],
    eyes: [
        "Cataract",
        "Watery Eyes",
        "Red Eye",
        "Vision Change",
        "Visual Loss",
        "Double Vision",
        "Blurred Vision",
        "Glaucoma",
        "Eye Irritation",
        "Flash Lights",
        "Unequal Pupils",
        "Eye Pain",
        "Involuntary Eye Movement",
        "Enlarged Pupil",
    ],
    enmt: [
        "Decreased Hearing",
        "Tinnitus",
        "Ear Pain",
        "Nose Bleeds",
        "Loss Of Smell",
        "Hoarseness",
        "Sore Throat",
        "Snoring",
        "Difficulty Swallowing",
        "Headaches",
        "Ringing",
        "Sinus Trouble",
        "Trauma",
        "Dry Mouth",
        "Mouth Ulcer",
    ],
    respiratory: [
        "Shortness Of Breath",
        "Cough",
        "Hoarseness",
        "Paroxysmal Nocturnal Dyspnea",
        "Sputum",
        "Painful Breathing",
        "Pleurisy",
        "Sneezing",
        "Hemoptysis",
        "Wheezing",
    ],
    cardiovascular: [
        "Chest Discomfort With Exertion",
        "Neck/Throat Discomfort With Exertion",
        "Arm Discomfort With Exertion",
        "Shortness Of Breath With Exertion",
        "Orthopnea",
        "Palpitations",
        "Lightheaded With Standing",
        "Dyspnea With Exertion",
        "Dyspnea At Rest",
        "Dyspnea When Supine",
        "Fainting Spells",
        "Nocturnal Dyspnea",
    ],
    gastrointestinal: [
        "Heartburn",
        "Excessive Appetite",
        "Nausea",
        "Vomiting",
        "Hiccups",
        "Dysphagia",
        "Melena",
        "Hemorrhoids",
        "Acid Reflux",
        "Constipation",
        "Abdominal Pain",
        "Hematemesis",
        "No Rectal Bleeding",
        "Bowel Movement Changes",
        "Diarrhea",
        "Dyspepsia",
    ],
    genitourinary: [
        "Increased Urinary Frequency",
        "Urinary Urgency",
        "Hematuria",
        "Incontinence",
        "Erectile Dysfunction",
        "Nocturia",
        "UTI",
        "Polyuria",
        "Diabetic Uropathy",
        "Kidney Stone",
        "Pelvic Pain",
        "Suprapubic Pain",
        "Bladder Fullness Discomfort",
        "Ketonuria",
        "Musty Urine Odor",
        "Sweet Urine Odor",
        "Foul Urine Odor",
        "Ammonia Odor",
    ],
    obstetrics: [
        "Low Libido",
        "Pelvic Pain",
        "Sexual Problems",
        "STDS",
        "Preeclampsia",
        "Ectopic Pregnancy",
        "High Blood Pressure",
        "Gestational Diabetes",
        "Lichen Sclerosus",
        "Vulvar Vestibulitis",
        "Vulvar Dystonia",
        "Muscle Aches",
        "Genetic Disorders",
        "Preterm Labor",
        "Stillbirth",
        "Infertility",
        "Lactating",
    ],
    gynaecology: [
        "Abnormal Vaginal Bleeding",
        "Fibroids",
        "Endometriosis",
        "Hormonal Contraception",
        "Cervical Ectropion",
        "Vaginitis",
        "Vaginal Atrophy",
        "Pelvic Pain",
        "Cervical Cancer",
        "Vaginal Cancer",
        "Vaginal Fistula",
        "STIs",
        "Pelvic Inflammatory Disease",
        "Cervicitis",
        "Gonorrhea",
        "Abdominal Pain",
        "UTI",
        "Menorrhagia Amenorrhea",
        "Adenomyosis",
        "Premenstrual Syndrome",
        "Premenstrual Dysphoric Disorder",
        "Dysmenorrhea",
        "Oligomenorrhea",
        "Dyspareunia",
        "Postpartum Amenorrhea",
        "Female Circumcision Type 3",
        "Postmenopausal",
        "Cervical Polyp",
    ],
    endocrine: [
        "Cold Intolerance",
        "Heat Intolerance",
        "Chronologically Overweight",
        "Chronologically Underweight",
        "Prolactinoma",
        "Cushing's Disease",
        "Hypothyroidism",
        "Increased Appetite",
        "Sweating",
        "Hair Loss",
        "Hair Growth",
        "Excessive Thirst",
        "Hyperthyroidism",
        "Addison's Disease",
        "Graves Disease",
        "Tension",
        "Anxiety",
        "Irritability",
        "Depressed Mood",
        "Overwhelmed",
        "Bloating",
        "Impaired Concentration",
        "Insomnia",
    ],
    psychiatric: [
        "Alcoholism",
        "Amnesia",
        "Anorexia",
        "Anxiety",
        "Confusion",
        "Delirium",
        "Depression",
        "Paranoia",
        "Suicidal Thoughts",
        "Stress",
        "Insomnia",
        "Postpartum Depression",
    ],
    musculoskeletal: [
        "Muscle Weakness",
        "Joint Pain/Stiffness",
        "Arthritis",
        "Back Pain",
        "Muscle Cramps",
    ],
    neurology: [
        "Headache",
        "Migraine Headache",
        "Numbness",
        "Fainting",
        "Vertigo",
        "Dizziness",
        "Face Pain",
        "Seizures",
        "Insomnia",
        "Neuropathy",
        "Sciatica",
        "Memory Loss",
        "Convulsions",
        "Hands And Feet Neuropathy",
    ],
    hematologic: [
        "Difficulty Clotting",
        "Swollen Glands",
        "Anemia",
        "Bleeding Tendency",
        "Easy Bruising",
        "Sickle Cell",
        "Thalassemia",
    ],
    allergic: ["Hay Fever", "Food Allergies", "Hives", "Bee Sting Allergies"],
    skin: [
        "Itching",
        "Discoloration",
        "Papules",
        "Pustules",
        "Cysts",
        "Nodules",
        "Scars",
        "Hair Loss",
        "Scaly Skin",
        "Vesicles",
        "Blisters",
        "Dry Skin",
        "Bumps",
        "Lumps",
        "Rash",
    ],
    rightBreast: [
        "Breast Pain",
        "Breast Lumps",
        "Swollen Lymph Nodes",
        "Nipple Discharge",
        "Redness Over The Skin",
        "Nipple Bleeding",
        "Dimpling On Breast",
        "Breast Tenderness",
        "Cyst",
        "Foul Smelling Discharge",
        "Breast Tumor",
        "Bloody Discharge",
        "Scaling Of The Skin",
    ],
    leftBreast: [
        "Breast Pain",
        "Breast Lumps",
        "Nipple Discharge",
        "Nipple Bleeding",
        "Breast Tenderness",
        "Cyst",
        "Breast Tumor",
        "Swollen Lymph Nodes",
        "Redness Over The Skin",
        "Dimpling On Breast",
        "Foul Smelling Discharge",
        "Bloody Discharge",
        "Scaling Of The Skin",
    ],
};

// Accordions definition
const PHYSICAL_EXAM_GROUPS = [
    { title: "❤️ Heart EXAMINATION", sections: [{ key: "heart", label: "HEART", showNotes: true }] },
    { title: "🫁 LUNGS Assessment", sections: [{ key: "lungs", label: "LUNGS", showNotes: true }] },
    {
        title: "👩‍⚕️ BREAST EXAMINATION",
        sections: [
            { key: "rightBreast", label: "RIGHT BREAST", showNotes: true },
            { key: "leftBreast", label: "LEFT BREAST", showNotes: true },
        ],
    },
    {
        title: "🧠 ABDOMEN",
        sections: [
            { key: "auscultation", label: "Auscultation / Inspection / Palpation", showNotes: true },
            { key: "hernia", label: "HERNIA", showNotes: true },
        ],
    },
    {
        title: "⚕️ PELVIS EXAMINATION",
        sections: [
            { key: "valva", label: "VULVA", showNotes: true }, // backend uses "valva"
            { key: "urethra", label: "URETHRA", showNotes: true },
            { key: "vagina", label: "VAGINA", showNotes: true },
        ],
    },
    { title: "🧠 RECTAL EXAM", sections: [{ key: "rectalExam", label: "RECTAL EXAM", showNotes: true }] },
    { title: "🩹 SKIN", sections: [{ key: "skin", label: "SKIN", showNotes: true }] },
    { title: "🦴 MUSCULOSKELETAL", sections: [{ key: "musculoskeletal", label: "MUSCULOSKELETAL", showNotes: true }] },
    { title: "🧠 NEUROLOGY", sections: [{ key: "neurology", label: "NEUROLOGY", showNotes: true }] },
    { title: "🧠 PSYCHIATRIC", sections: [{ key: "psychiatric", label: "PSYCHIATRIC", showNotes: true }] },

    // ROS
    { title: "🧠 CONSTITUTIONAL", sections: [{ key: "constitutional", label: "CONSTITUTIONAL" }] },
    { title: "🩹 INTEGUMENTARY (SKIN)", sections: [{ key: "integumentary", label: "INTEGUMENTARY (SKIN)" }] },
    { title: "👁️ EYES", sections: [{ key: "eyes", label: "EYES" }] },
    { title: "👂EARS / NOSE / MOUTH / THROAT", sections: [{ key: "enmt", label: "EARS, NOSE, MOUTH, THROAT" }] },
    { title: "🫁 RESPIRATORY EXAMINATION", sections: [{ key: "respiratory", label: "RESPIRATORY" }] },
    { title: "❤️ CARDIOVASCULAR EXAMINATION", sections: [{ key: "cardiovascular", label: "CARDIOVASCULAR" }] },
    { title: "🫁GASTROINTESTINAL", sections: [{ key: "gastrointestinal", label: "GASTROINTESTINAL" }] },
    { title: "♀️GYNECOLOGY", sections: [{ key: "gynaecology", label: "GYNAECOLOGY" }] },
    { title: "🔬ENDOCRINE", sections: [{ key: "endocrine", label: "ENDOCRINE" }] },
    { title: "🧬HEMATOLOGIC / LYMPHATIC", sections: [{ key: "hematologic", label: "HEMATOLOGIC / LYMPHATIC" }] },
    { title: "🛡️ALLERGIC OR IMMUNOLOGIC", sections: [{ key: "allergic", label: "ALLERGIC / IMMUNOLOGIC", showNotes: true }] },
    { title: "🩺GENITOURINARY", sections: [{ key: "genitourinary", label: "GENITOURINARY" }] },
    { title: "🤰OBSTETRICS", sections: [{ key: "obstetrics", label: "OBSTETRICS" }] },
    {
        title: "♀️UTERUS / PARAMETRIA",
        sections: [
            { key: "uterus", label: "UTERUS", showNotes: true },
            { key: "parametria", label: "PARAMETRIA", showNotes: true },
        ],
    },
];

const style1 = {
    position: "absolute",
    top: "54%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: "0px 0px 24px rgba(0, 0, 0, 0.5)",
    padding: "15px",
    borderRadius: "8px",
    maxHeight: "90vh",
    overflow: "auto",
};

const API_BASE_URL =
    process.env.NEXT_PUBLIC_API_BASE_URL || process.env.REACT_APP_API_URL;

const OBGYN = ({ data, onClose }) => {
    const { patientFormId, formTitle, practiceLogo, particeName } = data || {};

    const [patientId, setPatientId] = useState();
    const [clientSignatureDate, setClientSignatureDate] = useState(null);
    const [search, setSearch] = useState({});
    const [sections, dispatch] = useReducer(sectionsReducer, initialSections);

    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [staffid, setstaffid] = useState();
    const [patientproviderid, setpatientproviderid] = useState();
    const [customFormTitle, setcustomFormTitle] = useState("");
    const [assessmentDate, setassessmentDate] = useState("");
    const [createdDate, setCreatedDate] = useState(null);
    const [Error, setError] = useState(false);
    const [isPrinted, setisPrinted] = useState(false);
    const [isChecked, setisChecked] = useState(false);
    const [isAuditReady, setisAuditReady] = useState(false);
    const [formlock, setformlock] = useState(false);
    const [formlockcheck, setformlockcheck] = useState(false);
    const [accountNo, setaccountNo] = useState();
    const [practiceAddress, setpracticeAddress] = useState("");
    const [practicePhoneNo, setpracticePhoneNo] = useState("");
    const [practiceFax, setpracticeFax] = useState("");
    const [practiceWebsite, setpracticeWebsite] = useState("");
    const [isManualSubmit, setIsManualSubmit] = useState(false);
    const [patientDocumentUrl, setPatientDocumentUrl] = useState(null);
    const [docName, setDocName] = useState("");
    const [base64File, setBase64File] = useState("");
    const [PatientNameclient, setPatientNameclient] = useState("");
    const [patientName, setpatientName] = useState("");
    const [fomid, setfomid] = useState();
    const [practiceIds, setPracticeId] = useState(null);
    const [refreshTimer, setrefreshTimer] = useState(false);
    const [dataid, setdataid] = useState();
    const [submitting, setSubmitting] = useState(false);
    const [oppen, setoppen] = useState(false);
    const [openPatientForm, setopenPatientForm] = useState(false);
    const [Claimid, setClaimid] = useState("");
    const [Claimidnew, setClaimidnew] = useState("");
    const displayedClaimId = Claimidnew ? Claimidnew : Claimid ? Claimid : "";
    const [StaffSignatureid, setStaffSignatureid] = useState("");
    const [TreatmentDirectorid, setTreatmentDirectorid] = useState("");
    const [staffSignature, setstaffSignature] = useState(null);
    const [treatmentdirectorDate, settreatmentdirectorDate] = useState(null);
    const [professionalDate, setprofessionalDate] = useState(null);
    const [DOB, setDOB] = useState("");
    const [imageURLClientSignature, setImageURLClientSignature] = useState(null);
    const [imageURLClientSignatureview, setImageURLClientSignatureview] = useState(null);
    const [ClientSignature, setClientSignature] = useState(false);
    const [previewLinkClientSignature, setPreviewLinkClientSignature] = useState("");

    const printRef1 = useRef();
    const sigCanvasClientSignature = useRef({});

    const token = localStorage.getItem("neuro_patientportal_auth_token");
    const headers = { Authorization: `Bearer ${token}` };


    // ========================= SIGNATURE STATE =========================
  // patientSigLink: holds current client signature (either url or base64)
  const [patientSigLink, setPatientSigLink] = useState("");
  // sigCanvasRef: ref to SignatureCanvas to read/clear drawn signature
  const sigCanvasRef = useRef(null);
  // openClientSignatureModal: controls opening/closing of the signature dialog
  const [openClientSignatureModal, setOpenClientSignatureModal] =
    useState(false);
  // showSuccessAlert: controls the "Form Saved" popup overlay

  // ===================================================================

    // RHF defaults
    const defValues = {
        id: 0,
        customFormTitle: "",
        practiceId: 0,
        patientFormId: 0,
        createdDate: "",
        createdBy: "",
        updatedDate: "",
        updatedBy: "",
        Patient: "",
        Constitutional: "",
        INTEGUMENTARYSKIN: "",
        HEMATOLOGICALLYMPHATIC: "",
        EYES: "",
        EarsNoseMouthThroat: "",
        Respiratory: "",
        Endocrine: "",
        Psychiatric: "",
        Musculoskeletal: "",
        NeuroLogical: "",
        HematologicLymphatic: "",
        EllergicOrImmunologic: "",
        Allergy: "",
        Severity: "",
        REACTION: "",
        INTOLERANCE: "",
        CurrentMadication: "",
        Dosage: "",
        HPI: "",
        Frequesncy: "",
        Duration: "",
        Reason: "",
        MedicalHistory: "",
        ObstetricsHistory: "",
        BirthControlHistory: "",
        PapSmearHistory: "",
        MamogramHistory: "",
        asOn: "",
        nextEvaluation: "",
        endsAt: "",
        startAt: "",
        recommendation: "",
        PatientType: "",
        assessmentDate: "",
        AttendingProvider: "",
        ChiefComplaint: "",
        ReferingProvider: "",
        PrimaryCareProvider: "",
        ReasonForVisit: "",
        VisitInitiatedBy: "",
        DispositionReason: "",
        dob: "",
    };

    const { control, handleSubmit, setValue, getValues } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: defValues,
    });

    // Load signature preview link
    useEffect(() => {
        if (imageURLClientSignatureview != null) {
            const fileClientSignature = encodeURIComponent(imageURLClientSignatureview);
            axios
                .get(
                    `${process.env.REACT_APP_API_URL}/PatientDocument/ViewPatientDocument?path=${fileClientSignature}`,
                    { headers }
                )
                .then((response) => {
                    setPreviewLinkClientSignature(response.data);
                })
                .catch((error) => {
                    console.error("Error fetching document preview link:", error);
                });
        }
    }, [imageURLClientSignatureview]);

    // Load base Form data
    useEffect(() => {
        axios
            .get(`${API_BASE_URL}/Forms/GetPatientFormsbyId?Id=${patientFormId}`, { headers })
            .then((response) => {
                const data = response.data;

                setstaffid(data.staffid);
                setfomid(data.formId);
                setPatientId(data.patientId);
                setPracticeId(data.practiceId);

                setcustomFormTitle(data.customFormTitle || "");
                setValue("customFormTitle", data.customFormTitle || "");

                setpatientName(data.patientName || "");
                setPatientNameclient(data.patientName || "");

                setisPrinted(data.isPrinted || false);
                setisChecked(data.isChecked || false);
                setisAuditReady(data.isAuditReady || false);

                setformlock(data.formlock || false);
                setformlockcheck(data.formlock || false);

                setaccountNo(data.accountNo || "");
                setpatientproviderid(data.professionalURL || "");

                setClaimid(data.claimId || "");
                setClaimidnew(data.claimId || "");

                setpracticeAddress(data.practiceAddress || "");
                setpracticePhoneNo(data.practicePhoneNo || "");
                setpracticeFax(data.practiceFax || "");
                setpracticeWebsite(data.practiceWebsite || "");
                setCreatedDate(data.createdDate || null);

                const assessmentDate = data.assessmentDate
                    ? moment(data.assessmentDate).format("YYYY-MM-DD")
                    : "";
                setassessmentDate(assessmentDate);
                setValue("assessmentDate", assessmentDate);

                const dobDate = data.dob ? moment(data.dob).format("YYYY-MM-DD") : "";
                setDOB(dobDate);
                setValue("dob", dobDate);

                setStaffSignatureid(data.internSignURL || "");
                setTreatmentDirectorid(data.treatmentdirectorURL || "");

                setImageURLClientSignatureview(data.obgynurl || null);
                setImageURLClientSignature(data.OBGYNBase64 || null);

                if (data.patientSignatureDATE) {
                    const date = moment(data.patientSignatureDATE).format("YYYY-MM-DD hh:mm A");
                    setClientSignatureDate(date);
                }

                setstaffSignature(data.staffsignatureDATE || null);
                settreatmentdirectorDate(data.directorDate || null);
                setprofessionalDate(data.providerDate || null);

                setPatientDocumentUrl(data.patientDocumentURL || "");
            })
            .catch((error) => {
                console.error("Error fetching patient form:", error);
            });
    }, [setValue, patientFormId]);

    // Load OBGYN form data
    useEffect(() => {
        let active = true;

        axios
            .get(`${API_BASE_URL}/OBGYNForm/getOBGYNFormByFormId?patientFormId=${patientFormId}`, {
                headers,
            })
            .then((response) => {
                if (!active) return;

                const data = response.data || {};

                setformlock(data.formlock || false);
                setformlockcheck(data.formlock || false);

                // FIX: Do not overwrite accountNo with empty value
                if (data.accountNo != null && data.accountNo !== "") {
                    setaccountNo(data.accountNo);
                }

                setpatientproviderid(data.professionalURL || "");
                setClaimid(data.claimId || "");
                setClaimidnew(data.claimId || "");
                setpracticeAddress(data.practiceAddress || "");
                setpracticePhoneNo(data.practicePhoneNo || "");
                setpracticeFax(data.practiceFax || "");
                setpracticeWebsite(data.practiceWebsite || "");
                setValue("customFormTitle", data.customFormTitle || customFormTitle);

                const assessmentDate = data.assessmentDate
                    ? moment(data.assessmentDate).format("YYYY-MM-DD")
                    : "";
                setassessmentDate(assessmentDate);
                setValue("assessmentDate", assessmentDate);

                setCreatedDate(data.createdDate || null);

                const dob = data.dob ? moment(data.dob).format("YYYY-MM-DD") : "";
                if (dob) {
                    setDOB(dob);
                    setValue("dob", dob);
                }

                setStaffSignatureid(data.internSignURL || "");
                setTreatmentDirectorid(data.treatmentdirectorURL || "");
                setImageURLClientSignatureview(data.obgynurl || null);
                setImageURLClientSignature(data.obgynBase64 || null);

                if (data.patientSignatureDATE) {
                    setClientSignatureDate(
                        moment(data.patientSignatureDATE).format("YYYY-MM-DD hh:mm A")
                    );
                }

                setstaffSignature(data.staffsignatureDATE || null);
                settreatmentdirectorDate(data.directorDate || null);
                setprofessionalDate(data.providerDate || null);
                setPatientDocumentUrl(data.patientDocumentURL || null);

                // RHF scalar fields
                setValue("Patient", data.patient || "");
                setValue("Constitutional", data.constitutional || "");
                setValue("INTEGUMENTARYSKIN", data.integumentarySkin || "");
                setValue("EYES", data.eyes || "");
                setValue("EarsNoseMouthThroat", data.earsNoseMouthThroat || "");
                setValue("Respiratory", data.respiratory || "");
                setValue("Endocrine", data.endocrine || "");
                setValue("Psychiatric", data.psychiatric || "");
                setValue("Musculoskeletal", data.musculoskeletal || "");
                setValue("NeuroLogical", data.neurological || "");
                setValue("HEMATOLOGICALLYMPHATIC", data.hematologicallymphatic || "");
                setValue("EllergicOrImmunologic", data.ellergicOrImmunologic || "");
                setValue("Allergy", data.allergy || "");
                setValue("Severity", data.severity || "");
                setValue("REACTION", data.reaction || "");
                setValue("INTOLERANCE", data.intolerance || "");
                setValue("CurrentMadication", data.currentMadication || "");
                setValue("Dosage", data.dosage || "");
                setValue("HPI", data.hpi || "");
                setValue("Frequesncy", data.frequesncy || "");
                setValue("Duration", data.duration || "");
                setValue("Reason", data.reason || "");
                setValue("MedicalHistory", data.medicalHistory || "");
                setValue("ObstetricsHistory", data.obstetricsHistory || "");
                setValue("BirthControlHistory", data.birthControlHistory || "");
                setValue("PapSmearHistory", data.papSmearHistory || "");
                setValue("MamogramHistory", data.mamogramHistory || "");
                setValue("asOn", data.asOn || "");
                setValue(
                    "nextEvaluation",
                    data.nextEvaluation ? moment(data.nextEvaluation).format("YYYY-MM-DD") : ""
                );
                setValue(
                    "endsAt",
                    data.endsAt ? moment(data.endsAt).format("YYYY-MM-DD") : ""
                );
                setValue(
                    "startAt",
                    data.startAt ? moment(data.startAt).format("YYYY-MM-DD") : ""
                );
                setValue("recommendation", data.recommendation || "");
                setValue("PatientType", data.patientType || "");
                setValue("AttendingProvider", data.attendingProvider || "");
                setValue("ChiefComplaint", data.chiefComplaint || "");
                setValue("ReferingProvider", data.referingProvider || "");
                setValue("PrimaryCareProvider", data.primaryCareProvider || "");
                setValue("ReasonForVisit", data.reasonForVisit || "");
                setValue("VisitInitiatedBy", data.visitInitiatedBy || "");
                setValue("DispositionReason", data.dispositionReason || "");

                // Dual-list bulk hydrate
                const mapped = fromApiPayload(data);
                dispatch({ type: ACTIONS.BULK_SET, payload: mapped });
            })
            .catch((error) => console.error("Error fetching OBGYN form:", error));

        return () => {
            active = false;
        };
    }, [setValue, patientFormId, customFormTitle]);



    // ============ SIGNATURE HANDLERS ============

  // Open the signature modal (used for "Open signing window" and "Edit Signature")
  const openClientModal = () => setOpenClientSignatureModal(true);

  // Close the signature modal and clear the canvas
  const closeClientModal = () => {
    setOpenClientSignatureModal(false);
    if (sigCanvasRef.current) {
      sigCanvasRef.current.clear();
    }
  };

  // Save the drawn signature from canvas into component state
  // (patientSigLink) and close the modal
  const handleSaveClientSignature = () => {
    if (!sigCanvasRef.current) return;

    // Convert canvas signature to base64 PNG
    const dataUrl =
      sigCanvasRef.current.getCanvas().toDataURL("image/png");
    setPatientSigLink(dataUrl);
    closeClientModal();
  };

  // Delete the existing client signature, show confirmation popup, and
  // call API to clear it on the server
  const handleDeleteClientSignature = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to remove this signature?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, remove it!",
      didOpen: () => {
        const swalEl = document.querySelector(".swal2-container");
        if (swalEl) {
          swalEl.style.zIndex = "9999";
        }
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Remove from UI immediately
        setPatientSigLink("");

        try {
          const token = localStorage.getItem(
            "neuro_patientportal_auth_token"
          );
          if (!token) {
            throw new Error(
              "Authentication token not found. Please log in."
            );
          }

          // Call API to clear signature on backend
          const res = await fetch(`${API_BASE_URL}/Forms/AddPatientForm`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              patientFormId,
              clientsBase64: "",
              clientsURL: "",
            }),
          });

          if (!res.ok) {
            throw new Error("Failed to remove signature.");
          }

          // Success popup (SweetAlert)
          Swal.fire({
            title: "Deleted!",
            text: "Signature has been removed.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
            didOpen: () => {
              const swalEl =
                document.querySelector(".swal2-container");
              if (swalEl) {
                swalEl.style.zIndex = "9999";
              }
            },
          });
        } catch (e) {
          console.error(e);
          // Error popup
          Swal.fire({
            title: "Error!",
            text: e.message || "Failed to remove signature.",
            icon: "error",
            didOpen: () => {
              const swalEl =
                document.querySelector(".swal2-container");
              if (swalEl) {
                swalEl.style.zIndex = "9999";
              }
            },
          });
        }
      }
    });
  };

  // Save the form including the current signature (patientSigLink)
  // and show "Form Saved" popup overlay
  const handleSaveForm = async () => {
    if (!patientFormId) return;

    try {
      const token = localStorage.getItem(
        "neuro_patientportal_auth_token"
      );
      if (!token) {
        throw new Error(
          "Authentication token not found. Please log in."
        );
      }

      const res = await fetch(`${API_BASE_URL}/Forms/AddPatientForm`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          patientFormId,
          // send base64 signature to backend
          clientsBase64: patientSigLink || "",
          clientsURL: "",
        }),
      });

      if (!res.ok) {
        throw new Error("Failed to save form.");
      }

      // Show success overlay
      setShowSuccessAlert(true);

      // Hide overlay and close parent dialog/window after 1 second
      setTimeout(() => {
        setShowSuccessAlert(false);
        if (onClose) {
          onClose();
        }
      }, 1000);
    } catch (e) {
      console.error(e);
      alert(e.message || "Failed to save form.");
    }
  };

    // Dual-list handlers (no-ops in preview)
    const addKeyword = useCallback(
        (key, kw) => dispatch({ type: ACTIONS.ADD, key, keyword: kw }),
        []
    );
    const move = useCallback(
        (key, from, kw) => dispatch({ type: ACTIONS.MOVE, key, from, keyword: kw }),
        []
    );
    const selectAll = useCallback(
        (key) => dispatch({ type: ACTIONS.SELECT_ALL, key }),
        []
    );
    const clearAll = useCallback(
        (key) => dispatch({ type: ACTIONS.CLEAR_ALL, key }),
        []
    );
    const setNotes = useCallback(
        (key, notes) => dispatch({ type: ACTIONS.SET_NOTES, key, notes }),
        []
    );
    const onSearchChange = useCallback(
        (key, v) => setSearch((p) => ({ ...p, [key]: v })),
        []
    );
    const removeKeyword = useCallback(
        (key, from, keyword) =>
            dispatch({ type: ACTIONS.DELETE, key, from, keyword }),
        []
    );

    // Build physical-exam / ROS models
    const physExamModels = useMemo(() => {
        return PHYSICAL_EXAM_GROUPS.map((group) => ({
            title: group.title,
            sections: group.sections.map((s) => ({
                ...s,
                selected: sections[s.key]?.selected || [],
                unselected: sections[s.key]?.unselected || [],
                notes: s.showNotes ? sections[s.key]?.notes || "" : "",
                searchValue: search[s.key] || "",
            })),
        }));
    }, [sections, search]);

    // Signature helpers
    const handleOpenClientSignature = () => setClientSignature(true);
    const handleCloseClientSignature = () => setClientSignature(false);
    const saveClientSignature = async () => {
        setImageURLClientSignature(
            sigCanvasClientSignature.current.getTrimmedCanvas().toDataURL("")
        );
        handleCloseClientSignature();
    };
    const clearClientSignature = () => sigCanvasClientSignature.current.clear();

    const convertToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const onImageChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            setDocName(file.name);
            const base64 = await convertToBase64(file);
            setBase64File(base64);
        }
    };

    const handleClickOpen = () => setoppen(true);
    const handleClose = () => {
        setoppen(false);
    };
    const handleClosePatientForm = () => setopenPatientForm(false);
    const handleClickOpenPatientForm = () => setopenPatientForm(true);

    return (
        <>



        
            <style type="text/css" media="print">
                {`@page { size: A4 portrait; }`}
            </style>
{/* ================== SUCCESS POPUP OVERLAY ==================
          This block shows the "Form Saved" popup after handleSaveForm
          sets showSuccessAlert = true. It auto-hides after 1s. */}
      {showSuccessAlert && (
        <>
          {/* Dark full-screen backdrop */}
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1299,
            }}
          />
          {/* Centered success card */}
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "300px",
              padding: "20px",
            //   backgroundColor: "#fff",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              borderRadius: "8px",
              textAlign: "center",
              zIndex: 1300,
            }}
            // {showSuccessAlert && isManualSubmit ? (
            //     <div
            //         style={{
            //             position: "fixed",
            //             top: "50%",
            //             left: "50%",
            //             transform: "translate(-50%, -50%)",
            //             width: "300px",
            //             padding: "20px",
            //             backgroundColor: "#fff",
            //             boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            //             borderRadius: "8px",
            //             textAlign: "center",
            //             zIndex: 1300,
            //         }}
                >
                        <Typography
              variant="h6"
              style={{ marginBottom: "10px" }}
            >
              Form Saved
            </Typography>
            <Typography style={{ marginBottom: "20px" }}>
              Form saved successfully
            </Typography>
          </div>
        </>
      )}

            <form id="obgynForm">
                <div ref={printRef1}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                            <Grid
                                sx={{
                                    // background: "linear-gradient(135deg, #eef2f3 0%, #d9e7f2 100%)",
                                    p: 3,
                                    borderRadius: 3,
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                                    mt: 2,
                                }}
                            >
                                {/* Top header section: patient, title, etc */}
                                <Grid container spacing={2} className="print-content">
                                    {/* Patient */}
                                    <Grid item xs={6}>
                                        <InputLabel
                                            style={{
                                                fontWeight: "bold",
                                                color: "#004d61",
                                                marginBottom: "4px",
                                            }}
                                        >
                                            Patient
                                        </InputLabel>
                                        <div
                                            style={{
                                                borderRadius: "8px",
                                                padding: "2px",
                                                // background:
                                                //     "linear-gradient(90deg, #00b4d8, #90e0ef, #00b4d8)",
                                                backgroundSize: "100% 100%",
                                                animation: "pulseBorder 3s linear infinite",
                                            }}
                                        >
                                            <TextField
                                                fullWidth
                                                size="small"
                                                value={patientName || ""}
                                                onChange={(e) => {
                                                    setValue("Patient", e.target.value);
                                                    setpatientName(e.target.value);
                                                }}
                                                sx={{
                                                    backgroundColor: "white",
                                                    borderRadius: "8px",
                                                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                    <style>
                                        {`
                      @keyframes pulseBorder {
                        0% { background-position: 0% 50%; }
                        50% { background-position: 100% 50%; }
                        100% { background-position: 0% 50%; }
                      }
                    `}
                                    </style>

                                    {/* Title */}
                                    <Grid item xs={6}>
                                        <InputLabel
                                            style={{
                                                fontWeight: "bold",
                                                // color: "#004d61",
                                                marginBottom: "4px",
                                            }}
                                        >
                                            Title
                                        </InputLabel>
                                        <div
                                            style={{
                                                borderRadius: "8px",
                                                padding: "2px",
                                                // background:
                                                //     "linear-gradient(90deg, #00b4d8, #90e0ef, #00b4d8)",
                                                backgroundSize: "100% 100%",
                                                animation: "pulseBorder 3s linear infinite",
                                            }}
                                        >
                                            <Controller
                                                name="customFormTitle"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        size="small"
                                                        type="text"
                                                        sx={{
                                                            bgcolor: "white",
                                                            borderRadius: 1.5,
                                                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            field.onChange(value);
                                                            setValue("customFormTitle", value);
                                                            setcustomFormTitle(value);
                                                        }}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </Grid>

                                    {/* Patient Type */}
                                    <Grid item xs={6}>
                                        <InputLabel
                                            style={{
                                                fontWeight: "bold",
                                                // color: "#004d61",
                                                marginBottom: "4px",
                                            }}
                                        >
                                            Patient Type
                                        </InputLabel>
                                        <div
                                            style={{
                                                borderRadius: "8px",
                                                padding: "2px",
                                                // background:
                                                //     "linear-gradient(90deg, #00b4d8, #90e0ef, #00b4d8)",
                                                backgroundSize: "100% 100%",
                                                animation: "pulseBorder 3s linear infinite",
                                            }}
                                        >
                                            <Controller
                                                name="PatientType"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        size="small"
                                                        sx={{
                                                            bgcolor: "white",
                                                            borderRadius: 1.5,
                                                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                        }}
                                                        onChange={(e) =>
                                                            setValue("PatientType", e.target.value)
                                                        }
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </Grid>

                                    {/* Assessment Date */}
                                    <Grid item xs={6}>
                                        <InputLabel
                                            style={{
                                                fontWeight: "bold",
                                                // color: "#004d61",
                                                marginBottom: "4px",
                                            }}
                                        >
                                            Assessment Date
                                        </InputLabel>
                                        <Controller
                                            name="assessmentDate"
                                            control={control}
                                            render={({ field }) => (
                                                <div
                                                    style={{
                                                        borderRadius: "8px",
                                                        padding: "2px",
                                                        // background:
                                                        //     "linear-gradient(90deg, #00b4d8, #90e0ef, #00b4d8)",
                                                        backgroundSize: "100% 100%",
                                                        animation: "pulseBorder 3s linear infinite",
                                                    }}
                                                >
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        type="date"
                                                        size="small"
                                                        sx={{
                                                            bgcolor: "white",
                                                            borderRadius: 1.5,
                                                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                        }}
                                                        value={assessmentDate || ""}
                                                        onChange={(e) => {
                                                            setValue("assessmentDate", e.target.value);
                                                            setassessmentDate(e.target.value);
                                                            setError(false);
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        />
                                        {Error && (
                                            <Typography
                                                sx={{
                                                    color: "red",
                                                    fontSize: "13px",
                                                    mt: 0.5,
                                                }}
                                            >
                                                Please select a valid date.
                                            </Typography>
                                        )}
                                    </Grid>

                                    {/* Attending Provider */}
                                    <Grid item xs={6}>
                                        <InputLabel
                                            style={{
                                                fontWeight: "bold",
                                                // color: "#004d61",
                                                marginBottom: "4px",
                                            }}
                                        >
                                            Attending Provider
                                        </InputLabel>
                                        <div
                                            style={{
                                                borderRadius: "8px",
                                                padding: "2px",
                                                // background:
                                                //     "linear-gradient(90deg, #00b4d8, #90e0ef, #00b4d8)",
                                                backgroundSize: "100% 100%",
                                                animation: "pulseBorder 3s linear infinite",
                                            }}
                                        >
                                            <Controller
                                                name="AttendingProvider"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        size="small"
                                                        sx={{
                                                            bgcolor: "white",
                                                            borderRadius: 1.5,
                                                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                        }}
                                                        onChange={(e) =>
                                                            setValue("AttendingProvider", e.target.value)
                                                        }
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </Grid>

                                    {/* Chief Complaint */}
                                    <Grid item xs={6}>
                                        <InputLabel
                                            style={{
                                                fontWeight: "bold",
                                                // color: "#004d61",
                                                marginBottom: "4px",
                                            }}
                                        >
                                            Chief Complaint
                                        </InputLabel>
                                        <Controller
                                            name="ChiefComplaint"
                                            control={control}
                                            render={({ field }) => (
                                                <div
                                                    style={{
                                                        borderRadius: "8px",
                                                        padding: "2px",
                                                        // background:
                                                        //     "linear-gradient(90deg, #00b4d8, #90e0ef, #00b4d8)",
                                                        backgroundSize: "100% 100%",
                                                        animation: "pulseBorder 3s linear infinite",
                                                    }}
                                                >
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        size="small"
                                                        sx={{
                                                            bgcolor: "white",
                                                            borderRadius: 1.5,
                                                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                        }}
                                                        onChange={(e) =>
                                                            setValue("ChiefComplaint", e.target.value)
                                                        }
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        />
                                    </Grid>

                                    {/* Referring Provider */}
                                    <Grid item xs={6}>
                                        <InputLabel
                                            style={{
                                                fontWeight: "bold",
                                                // color: "#004d61",
                                                marginBottom: "4px",
                                            }}
                                        >
                                            Referring Provider
                                        </InputLabel>
                                        <div
                                            style={{
                                                borderRadius: "8px",
                                                padding: "2px",
                                                // background:
                                                //     "linear-gradient(90deg, #00b4d8, #90e0ef, #00b4d8)",
                                                backgroundSize: "100% 100%",
                                                animation: "pulseBorder 3s linear infinite",
                                            }}
                                        >
                                            <Controller
                                                name="ReferingProvider"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        size="small"
                                                        sx={{
                                                            bgcolor: "white",
                                                            borderRadius: 1.5,
                                                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                        }}
                                                        onChange={(e) =>
                                                            setValue("ReferingProvider", e.target.value)
                                                        }
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </Grid>

                                    {/* Primary Care Provider */}
                                    <Grid item xs={6}>
                                        <InputLabel
                                            style={{
                                                fontWeight: "bold",
                                                color: "#004d61",
                                                marginBottom: "4px",
                                            }}
                                        >
                                            Primary Care Provider
                                        </InputLabel>
                                        <div
                                            style={{
                                                borderRadius: "8px",
                                                padding: "2px",
                                                // background:
                                                //     "linear-gradient(90deg, #00b4d8, #90e0ef, #00b4d8)",
                                                backgroundSize: "100% 100%",
                                                animation: "pulseBorder 3s linear infinite",
                                            }}
                                        >
                                            <Controller
                                                name="PrimaryCareProvider"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        size="small"
                                                        sx={{
                                                            bgcolor: "white",
                                                            borderRadius: 1.5,
                                                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                        }}
                                                        onChange={(e) =>
                                                            setValue("PrimaryCareProvider", e.target.value)
                                                        }
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>

                                {/* Flags + Print + Doc + Claims */}
                                <Grid
                                    container
                                    spacing={2}
                                    alignItems="center"
                                    style={{ margin: "0px 10px" }}
                                >
                                    <Grid item xs={0.3}>
                                        <input
                                            type="checkbox"
                                            name="isPrinted"
                                            checked={isPrinted || false}
                                            disabled
                                            style={{
                                                width: "16px",
                                                height: "16px",
                                                marginTop: "5px",
                                                cursor: "not-allowed",
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <label style={{ marginTop: "7px", cursor: "default" }}>
                                            Printed and Filed
                                        </label>
                                    </Grid>

                                    <Grid item xs={0.3}>
                                        <input
                                            type="checkbox"
                                            name="isChecked"
                                            checked={isChecked || false}
                                            disabled
                                            style={{
                                                width: "16px",
                                                height: "16px",
                                                marginTop: "5px",
                                                cursor: "not-allowed",
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <label style={{ marginTop: "7px", cursor: "default" }}>
                                            Inactive
                                        </label>
                                    </Grid>

                                    <Grid item xs={0.3}>
                                        <input
                                            type="checkbox"
                                            name="isAuditReady"
                                            checked={isAuditReady || false}
                                            disabled
                                            style={{
                                                width: "16px",
                                                height: "16px",
                                                marginTop: "5px",
                                                cursor: "not-allowed",
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <label style={{ marginTop: "7px", cursor: "default" }}>
                                            Audit Ready
                                        </label>
                                    </Grid>

                                    <Grid item xs={0.3}>
                                        <input
                                            type="checkbox"
                                            name="formlock"
                                            checked={formlock || false}
                                            disabled
                                            style={{
                                                width: "16px",
                                                height: "16px",
                                                marginTop: "5px",
                                                cursor: "not-allowed",
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={2.3}>
                                        <label style={{ marginTop: "7px", cursor: "default" }}>
                                            Lock
                                        </label>
                                        {formlockcheck && formlock && (
                                            <Typography
                                                style={{ fontWeight: "bold", color: "red" }}
                                            >
                                                Changing will not be saved
                                            </Typography>
                                        )}
                                    </Grid>
                                    <Grid item xs={0.3}></Grid>

                                    <Grid item xs={6}>
                                        {patientDocumentUrl && (
                                            <Button
                                                variant="contained"
                                                style={{
                                                    marginTop: "10px",
                                                    width: "100%",
                                                    height: "35px",
                                                    color: "blue",
                                                    fontSize: "14px",
                                                    // backgroundColor: "#ffff",
                                                }}
                                                onClick={() => {
                                                    const url = `${process.env.REACT_APP_API_URL}/PatientDocument/ViewPatientDocument?path=${encodeURIComponent(
                                                        patientDocumentUrl
                                                    )}`;
                                                    window.open(
                                                        url,
                                                        "_blank",
                                                        "noopener,noreferrer"
                                                    );
                                                }}
                                            >
                                                View Document
                                            </Button>
                                        )}

                                        <label htmlFor="icon-button-file">
                                            <input
                                                id="choosefile"
                                                style={{ display: "none" }}
                                                type="file"
                                                name="upload"
                                                accept="application/pdf"
                                                onChange={onImageChange}
                                                disabled
                                            />
                                        </label>
                                    </Grid>

                                    {displayedClaimId > 0 ? (
                                        <Grid item xs={3} style={{ marginTop: "-0.4rem" }}>
                                            <Button
                                                onClick={handleClickOpenPatientForm}
                                                variant="text"
                                                style={{
                                                    float: "left",
                                                    width: "100%",
                                                    height: "35px",
                                                    // color: "#2EA4D6",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                <AddOutlinedIcon
                                                    fontSize="small"
                                                    style={{
                                                        color: "blue",
                                                        marginBottom: "3px",
                                                        marginRight: 5,
                                                    }}
                                                />
                                                Open Claim
                                            </Button>
                                        </Grid>
                                    ) : (
                                        <Grid item xs={3}></Grid>
                                    )}
                                </Grid>

                                {/* Patient strip */}
                                <Grid
                                    container
                                    spacing={2}
                                    sx={{
                                        // background:
                                        //     "linear-gradient(135deg, #f0f7f7 0%, #e8f1f2 100%)",
                                        borderRadius: 3,
                                        p: 3,
                                        mt: "8px",
                                        boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <Grid item xs={2}>
                                        <Typography
                                            sx={{
                                                fontWeight: "bold",
                                                color: "#004d40",
                                                fontSize: "14px",
                                            }}
                                        >
                                            Client Name:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography
                                            sx={{ color: "", fontWeight: "bold" }}
                                        >
                                            {PatientNameclient}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={1}>
                                        <Typography
                                            sx={{
                                                fontWeight: "bold",
                                                color: "",
                                                fontSize: "14px",
                                            }}
                                        >
                                            Client DOB:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Controller
                                            name="dob"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    size="small"
                                                    type="date"
                                                    value={DOB || ""}
                                                    onChange={(e) => {
                                                        setValue("dob", e.target.value);
                                                        setDOB(e.target.value);
                                                    }}
                                                    InputProps={{ readOnly: true }}
                                                    sx={{
                                                        "& .MuiInputBase-input": {
                                                            color: "",
                                                            fontWeight: 500,
                                                        },
                                                        // backgroundColor: "#ffffff",
                                                        borderRadius: 2,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <Typography
                                            sx={{
                                                fontWeight: "bold",
                                                // color: "#004d40",
                                                fontSize: "14px",
                                            }}
                                        >
                                            File ID#:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography
                                            sx={{ fontWeight: "bold", color: "#00695c" }}
                                        >
                                            {accountNo}
                                        </Typography>
                                    </Grid>
                                </Grid>

                                {/* Reason For Visit - styled like Allergies card */}
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        // background: "linear-gradient(135deg, #e9f5ff 0%, #f6fbff 100%)",
                                        borderRadius: "16px",
                                        padding: "32px",
                                        marginTop: "20px",
                                        boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                                        backdropFilter: "blur(6px)",
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: "bold",
                                            color: "#0a2540",
                                            mb: 2,
                                            textAlign: "center",
                                            letterSpacing: "0.5px",
                                        }}
                                    >
                                        Reason For Visit
                                    </Typography>

                                    <Box
                                        sx={{
                                            width: "100%",
                                            height: "2px",
                                            // backgroundColor: "#d0d8e0",
                                            mb: 3,
                                        }}
                                    />

                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            // backgroundColor: "rgba(255,255,255,0.85)",
                                            borderRadius: "12px",
                                            p: 2,
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                        }}
                                    >
                                        {/* Reason For Visit – full width (new line) */}
                                        <Grid item xs={12}>
                                            <Typography
                                                sx={{
                                                    color: "#0a2540",
                                                    fontWeight: "bold",
                                                    mb: 1,
                                                    fontSize: "14px",
                                                }}
                                            >
                                                Reason For Visit
                                            </Typography>
                                            <Controller
                                                name="ReasonForVisit"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        multiline
                                                        minRows={2}
                                                        maxRows={6}
                                                        variant="outlined"
                                                        placeholder="Enter Reason For Visit"
                                                        sx={{
                                                            backgroundColor: "white",
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: "8px",
                                                            },
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        {/* Visit Initiated By – full width (another new line) */}
                                        <Grid item xs={12}>
                                            <Typography
                                                sx={{
                                                    color: "#0a2540",
                                                    fontWeight: "bold",
                                                    mb: 1,
                                                    fontSize: "14px",
                                                }}
                                            >
                                                Visit Initiated By
                                            </Typography>
                                            <Controller
                                                name="VisitInitiatedBy"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        multiline
                                                        minRows={2}
                                                        maxRows={6}
                                                        variant="outlined"
                                                        placeholder="Enter Visit Initiated By"
                                                        sx={{
                                                            backgroundColor: "white",
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: "8px",
                                                            },
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* HPI */}
                                <Grid item xs={12}>
                                    <Typography
                                        sx={{
                                            // color: "#004d40",
                                            fontWeight: "bold",
                                            mb: 1,
                                            fontSize: "15px",
                                        }}
                                    >
                                        HPI
                                    </Typography>
                                    <Controller
                                        name="HPI"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                multiline
                                                variant="outlined"
                                                placeholder="Enter HPI details..."
                                                sx={{
                                                    // backgroundColor: "#ffffff",
                                                    borderRadius: 2,
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>

                                {/* Allergies + Meds */}
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        // background:
                                        //     "linear-gradient(135deg, #e9f5ff 0%, #f6fbff 100%)",
                                        borderRadius: "16px",
                                        padding: "32px",
                                        marginTop: "20px",
                                        boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                                        backdropFilter: "blur(6px)",
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: "bold",
                                            color: "#0a2540",
                                            mb: 2,
                                            textAlign: "center",
                                            letterSpacing: "0.5px",
                                        }}
                                    >
                                        ALLERGIES
                                    </Typography>
                                    <Box
                                        sx={{
                                            width: "100%",
                                            height: "2px",
                                            // backgroundColor: "#d0d8e0",
                                            mb: 3,
                                        }}
                                    />
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            // backgroundColor: "rgba(255,255,255,0.85)",
                                            borderRadius: "12px",

                                            p: 2,
                                            mb: 4,
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                        }}
                                    >
                                        {[
                                            {
                                                name: "Allergy",
                                                label: "Allergy",

                                                placeholder: "Enter Allergy",
                                            },
                                            {
                                                name: "Severity",
                                                label: "Severity",
                                                placeholder: "Enter Severity",
                                            },
                                            {
                                                name: "REACTION",
                                                label: "Reaction",
                                                placeholder: "Enter Reaction",
                                            },
                                            {
                                                name: "INTOLERANCE",
                                                label: "Intolerance",
                                                placeholder: "Enter Intolerance",
                                            },
                                        ].map((item) => (
                                            <Grid item xs={12} sm={6} md={3} key={item.name}>
                                                <Typography
                                                    sx={{
                                                        color: "#0a2540",
                                                        fontWeight: "bold",
                                                        mb: 1,
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    {item.label}
                                                </Typography>
                                                <Controller
                                                    name={item.name}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            multiline
                                                            minRows={2}
                                                            maxRows={6}
                                                            variant="outlined"
                                                            placeholder={item.placeholder}
                                                            sx={{
                                                                backgroundColor: "white",
                                                                "& .MuiOutlinedInput-root": {
                                                                    borderRadius: "8px",
                                                                    alignItems: "flex-start",
                                                                },
                                                            }}
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>

                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: "bold",
                                            color: "#0a2540",
                                            mb: 2,
                                            textAlign: "center",
                                            letterSpacing: "0.5px",
                                        }}
                                    >
                                        CURRENT MEDICATION
                                    </Typography>
                                    <Box
                                        sx={{
                                            width: "100%",
                                            height: "2px",
                                            // backgroundColor: "#d0d8e0",
                                            mb: 3,
                                        }}
                                    />
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            // backgroundColor: "rgba(255,255,255,0.85)",
                                            borderRadius: "12px",
                                            p: 2,
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                        }}
                                    >
                                        {[
                                            {
                                                name: "CurrentMadication",
                                                label: "Current Medication",
                                                placeholder: "Enter Current Medication",
                                            },
                                            {
                                                name: "Dosage",
                                                label: "Dosage",
                                                placeholder: "Enter Dosage",
                                            },
                                            {
                                                name: "Frequesncy",
                                                label: "Frequency",
                                                placeholder: "Enter Frequency",
                                            },
                                            {
                                                name: "Duration",
                                                label: "Duration",
                                                placeholder: "Enter Duration",
                                            },
                                            {
                                                name: "Reason",
                                                label: "Reason",
                                                placeholder: "Enter Reason",
                                            },
                                        ].map((item) => (
                                            <Grid
                                                item
                                                xs={12}
                                                sm={6}
                                                md={item.name === "CurrentMadication" ? 4 : 2.4}
                                                key={item.name}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: "#0a2540",
                                                        fontWeight: "bold",
                                                        mb: 1,
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    {item.label}
                                                </Typography>
                                                <Controller
                                                    name={item.name}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            multiline
                                                            minRows={2}
                                                            maxRows={6}
                                                            variant="outlined"
                                                            placeholder={item.placeholder}
                                                            sx={{
                                                                backgroundColor: "white",
                                                                "& .MuiOutlinedInput-root": {
                                                                    borderRadius: "8px",
                                                                    alignItems: "flex-start",
                                                                },
                                                            }}
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>

                                {/* Past History + OBGYN History */}
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        // background:
                                        //     "linear-gradient(135deg, #f2faff 0%, #e6f3ff 100%)",
                                        borderRadius: "16px",
                                        padding: "32px",
                                        marginTop: "20px",
                                        boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                                        backdropFilter: "blur(6px)",
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            color: "#0a2540",
                                            fontWeight: "bold",
                                            mb: 1,
                                            textAlign: "center",
                                        }}
                                    >
                                        PAST HISTORY
                                    </Typography>
                                    <Box
                                        sx={{
                                            width: "100%",
                                            height: "2px",
                                            // backgroundColor: "#d0d8e0",
                                            mb: 3,
                                        }}
                                    />

                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            // backgroundColor: "rgba(255,255,255,0.85)",
                                            borderRadius: "12px",
                                            p: 2,
                                            mb: 4,
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                        }}
                                    >
                                        <Grid item xs={12}>
                                            <Typography
                                                sx={{
                                                    fontWeight: "bold",
                                                    color: "#0a2540",
                                                    fontSize: "14px",
                                                    mb: 1,
                                                }}
                                            >
                                                Medical History
                                            </Typography>
                                            
                                            <Controller
                                                name="MedicalHistory"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        multiline
                                                        minRows={2}
                                                        maxRows={6}
                                                        variant="outlined"
                                                        placeholder="Enter Medical History"
                                                        sx={{
                                                            backgroundColor: "white",
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: "8px",
                                                            },
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                )}
                                            />
                                        
                                        </Grid>
                                    </Grid>

                                    <Typography
                                        variant="h6"
                                        sx={{
                                            color: "#0a2540",
                                            fontWeight: "bold",
                                            mb: 1,
                                            textAlign: "center",
                                        }}
                                    >
                                        OBGYN HISTORY
                                    </Typography>
                                    <Box
                                        sx={{
                                            width: "100%",
                                            height: "2px",
                                            // backgroundColor: "#d0d8e0",
                                            mb: 3,
                                        }}
                                    />
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            // backgroundColor: "rgba(255,255,255,0.85)",
                                            borderRadius: "12px",
                                            p: 2,
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",

                                        }}
                                    >
                                        {[
                                            {
                                                name: "ObstetricsHistory",
                                                label: "Obstetrics History",
                                                placeholder: "Enter Obstetrics History",
                                            },
                                            {
                                                name: "BirthControlHistory",
                                                label: "Birth Control History",
                                                placeholder: "Enter Birth Control History",
                                            },
                                            {
                                                name: "PapSmearHistory",
                                                label: "Pap Smear History",
                                                placeholder: "Enter Pap Smear History",
                                            },
                                            {
                                                name: "MamogramHistory",
                                                label: "Mammogram History",
                                                placeholder: "Enter Mammogram History",
                                            },
                                        ].map((item) => (
                                            <Grid item xs={12} sm={6} key={item.name}>
                                                <Typography
                                                    sx={{
                                                        fontWeight: "bold",
                                                        color: "#0a2540",
                                                        fontSize: "14px",
                                                        mb: 1,
                                                    }}
                                                >
                                                    {item.label}
                                                </Typography>
                                                <Controller
                                                    name={item.name}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}

                                                            fullWidth

                                                            multiline

                                                            variant="outlined"
                                                            placeholder={item.placeholder}
                                                            sx={{
                                                                backgroundColor: "white",
                                                                "& .MuiOutlinedInput-root": {
                                                                    borderRadius: "8px",
                                                                },
                                                            }}
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>

                                {/* Timing + Plan */}
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        // background:
                                        //     "linear-gradient(135deg, #f0faff 0%, #e6f3ff 100%)",
                                        borderRadius: "16px",
                                        p: 3,
                                        boxShadow: "0 8px 18px rgba(0,0,0,0.08)",
                                        backdropFilter: "blur(6px)",
                                        mb: 4,
                                        mt: 2,

                                    }}
                                >
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            mb: 3,
                                            // backgroundColor: "rgba(255,255,255,0.85)",
                                            borderRadius: "10px",
                                            p: 3,
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",


                                        }}
                                    >
                                        <Grid container alignItems="center" spacing={2}>
                                            <Grid item xs={3}>
                                                <Typography
                                                    sx={{
                                                        fontWeight: "bold",
                                                        color: "#0a2540",
                                                        fontSize: "14px",

                                                    }}
                                                >
                                                    AS ON
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={9}>
                                                <Controller
                                                    name="asOn"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            size="small"
                                                            fullWidth
                                                            type="datetime-local"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{
                                                                backgroundColor: "white",
                                                                "& .MuiOutlinedInput-root": {
                                                                    borderRadius: "8px",

                                                                },
                                                            }}
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            mb: 3,
                                            // backgroundColor: "rgba(255,255,255,0.85)",
                                            borderRadius: "10px",
                                            p: 2,
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                        }}
                                    >
                                        <Grid container spacing={2} alignItems="center">
                                            {[
                                                { name: "nextEvaluation", label: "Next Evaluation" },
                                                { name: "startAt", label: "Start At" },
                                                { name: "endsAt", label: "Ends At" },
                                            ].map((item) => (
                                                <Grid item xs={12} sm={4} key={item.name}>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "bold",
                                                            color: "#0a2540",
                                                            fontSize: "14px",
                                                            mb: 1,
                                                        }}
                                                    >
                                                        {item.label}
                                                    </Typography>
                                                    <Controller
                                                        name={item.name}
                                                        control={control}
                                                        render={({ field }) => (
                                                            <TextField
                                                                {...field}
                                                                type="date"
                                                                size="small"
                                                                fullWidth
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    backgroundColor: "white",
                                                                    "& .MuiOutlinedInput-root": {
                                                                        borderRadius: "8px",
                                                                    },
                                                                }}
                                                                value={field.value || ""}
                                                                onChange={(e) =>
                                                                    setValue(item.name, e.target.value)
                                                                }
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            // backgroundColor: "rgba(255,255,255,0.85)",
                                            borderRadius: "10px",
                                            p: 2,
                                            mb: 2,
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#0a2540",
                                                fontWeight: "bold",
                                                fontSize: "14px",
                                                mb: 1,
                                            }}
                                        >
                                            Recommendation
                                        </Typography>
                                        <Controller
                                            name="recommendation"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    size="small"
                                                    fullWidth


                                                    multiline

                                                    variant="outlined"

                                                    placeholder="Enter Recommendation"
                                                    sx={{
                                                        backgroundColor: "white",
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: "8px",
                                                        },
                                                    }}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            // backgroundColor: "rgba(255,255,255,0.85)",
                                            borderRadius: "10px",
                                            p: 2,
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#0a2540",
                                                fontWeight: "bold",
                                                fontSize: "14px",
                                                mb: 1,
                                            }}
                                        >
                                            Disposition Reason
                                        </Typography>
                                        <Controller
                                            name="DispositionReason"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    size="small"
                                                    fullWidth


                                                    multiline

                                                    variant="outlined"
                                                    placeholder="Enter Disposition Reason"
                                                    sx={{
                                                        backgroundColor: "white",
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: "8px",
                                                        },
                                                    }}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>

                                {/* PHYSICAL EXAM + ROS dynamic accordions - preview only */}
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        // background:
                                        //     "linear-gradient(135deg, #f2faff 0%, #e6f3ff 100%)",
                                        borderRadius: "16px",
                                        padding: "32px",
                                        marginTop: "20px",
                                        boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                                        backdropFilter: "blur(6px)",
                                    }}
                                >
                                    {(() => {
                                        const psychIndex = physExamModels.findIndex((g) =>
                                            g.title.includes("PSYCHIATRIC")
                                        );
                                        const physExamGroupsPE =
                                            psychIndex >= 0
                                                ? physExamModels.slice(0, psychIndex + 1)
                                                : physExamModels;
                                        const physExamGroupsROS =
                                            psychIndex >= 0
                                                ? physExamModels.slice(psychIndex + 1)
                                                : [];

                                        return (
                                            <>
                                                <Typography
                                                    variant="h6"
                                                    sx={{
                                                        color: "#0a2540",
                                                        fontWeight: "bold",
                                                        mb: 1,
                                                        textAlign: "center",
                                                        letterSpacing: "0.5px",
                                                    }}
                                                >
                                                    PHYSICAL EXAM
                                                </Typography>
                                                {physExamGroupsPE.map((acc) => (
                                                    <ObgyngenericAccordion
                                                        key={acc.title}
                                                        title={acc.title}
                                                        sections={acc.sections}
                                                        optionsByKey={PRESET_OPTIONS}
                                                        editable={false}
                                                        // All handlers are no-ops in preview mode
                                                        onAddKeyword={() => { }}
                                                        onToggleUnToSel={() => { }}
                                                        onToggleSelToUn={() => { }}
                                                        onClearAll={() => { }}
                                                        onSelectAll={() => { }}
                                                        onSearchChange={() => { }}
                                                        onNotesChange={() => { }}
                                                        onDeleteUnselected={() => { }}
                                                    />
                                                ))}

                                                {physExamGroupsROS.length > 0 && (
                                                    <>
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                color: "#0a2540",
                                                                fontWeight: "bold",
                                                                mt: 4,
                                                                mb: 1,
                                                                textAlign: "center",
                                                                letterSpacing: "0.5px",
                                                            }}
                                                        >
                                                            Review of Systems
                                                        </Typography>

                                                        {physExamGroupsROS.map((acc) => (
                                                            <ObgyngenericAccordion
                                                                key={acc.title}
                                                                title={acc.title}
                                                                sections={acc.sections}
                                                                optionsByKey={PRESET_OPTIONS}
                                                                editable={false}
                                                                onAddKeyword={() => { }}
                                                                onToggleUnToSel={() => { }}
                                                                onToggleSelToUn={() => { }}
                                                                onClearAll={() => { }}
                                                                onSelectAll={() => { }}
                                                                onSearchChange={() => { }}
                                                                onNotesChange={() => { }}
                                                                onDeleteUnselected={() => { }}
                                                            />
                                                        ))}
                                                    </>
                                                )}
                                            </>
                                        );
                                    })()}
                                </Grid>

                                {/* Signature block - preview only, no editing */}
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <tbody>
                                        <tr>
                                            <td
                                                style={{
                                                    padding: "8px",
                                                    width: "16%",
                                                    marginLeft: "30px",
                                                    fontSize: "25px",
                                                    fontWeight: "bold",
                                                    textAlign: "center",
                                                    verticalAlign: "middle",
                                                }}
                                            >
                                                <Typography variant="body1">OBGYN</Typography>
                                            </td>
                                            <td
                                                style={{
                                                    padding: "8px",
                                                    width: "25%",
                                                    verticalAlign: "middle",
                                                }}
                                            >
                                                {!imageURLClientSignatureview ? (
                                                    imageURLClientSignature ? (
                                                        <img
                                                            src={imageURLClientSignature}
                                                            alt="Signature"
                                                            style={{
                                                                display: "block",
                                                                width: "200px",
                                                                height: "80px",
                                                                border: "2px solid #000",
                                                                // backgroundColor: "#f5f5f5",
                                                                padding: "10px",
                                                                boxSizing: "border-box",
                                                                borderRadius: "8px",
                                                            }}
                                                        />
                                                    ) : (
                                                        <Typography>No signature on file</Typography>
                                                    )
                                                ) : previewLinkClientSignature ? (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "10px",
                                                        }}
                                                    >
                                                        <img
                                                            src={previewLinkClientSignature}
                                                            alt="Signature"
                                                            style={{
                                                                display: "block",
                                                                width: "200px",
                                                                height: "80px",
                                                                border: "2px solid #000",
                                                                // backgroundColor: "#f5f5f5",
                                                                padding: "10px",
                                                                boxSizing: "border-box",
                                                                borderRadius: "8px",
                                                            }}
                                                        />
                                                    </div>
                                                ) : (
                                                    <Typography>Loading document...</Typography>
                                                )}
                                            </td>
                                            <td
                                                style={{
                                                    padding: "8px",
                                                    width: "25%",
                                                    verticalAlign: "middle",
                                                }}
                                            >
                                                {/* Remove-sign button removed for preview-only mode */}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Grid>
                        </tbody>
                    </table>
                </div>
            </form>

            {/* Signature Modal exists but cannot be opened since we removed all triggers */}
            {!imageURLClientSignatureview && (
                <Modal
                    style={{ marginTop: "-80px", overflow: "hidden", marginLeft: "300px" }}
                    open={ClientSignature}
                    onClose={handleCloseClientSignature}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className="popup-container" style={{ width: "500px" }}>
                        <Grid container spacing={1}>
                            <Grid item xs={11}>
                                <Typography
                                    style={{
                                        fontWeight: "bold",
                                        color: "black",
                                        textDecoration: "underline",
                                        fontSize: "16px",
                                    }}
                                >
                                    Add Signature
                                </Typography>
                            </Grid>
                            <Grid item xs={1}>
                                <CancelOutlinedIcon
                                    onClick={handleCloseClientSignature}
                                    fontSize="medium"
                                    style={{
                                        color: "red",
                                        paddingRight: "5px",
                                        cursor: "pointer",
                                        float: "right",
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            spacing={1}
                            style={{
                                marginTop: "40px",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Grid
                                item
                                xs={12}
                                style={{ border: "1px solid black", margin: "15px" }}
                            >
                                <SignaturePad
                                    ref={sigCanvasClientSignature}
                                    canvasProps={{ style: { width: "90%" } }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Button className="custom-button" onClick={saveClientSignature}>
                                    Save
                                </Button>
                            </Grid>
                            <Grid item xs={4}>
                                <Button
                                    className="custom-button"
                                    style={{ marginLeft: "20px" }}
                                    onClick={clearClientSignature}
                                >
                                    Clear
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Modal>
            )}

            {/* Claim view modal */}
            <Modal
                style={{ marginTop: "-80px", overflow: "hidden" }}
                open={openPatientForm}
                onClose={handleClosePatientForm}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="glassmorphic-card"
            >
                <Box
                    className="popup-container"
                    style={{ width: "1250px", height: "570px" }}
                >
                    <Grid container spacing={1} style={{ marginBottom: "20px" }}>
                        <Grid item xs={11}>
                            <Typography
                                variant="h5"
                                style={{ color: "black", fontWeight: "bold" }}
                            >
                                Claim
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton
                                onClick={handleClosePatientForm}
                                className="cancel-icon-button "
                                style={{ float: "right" }}
                            >
                                <CancelTwoToneIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>



             {/* ========================= SIGNATURE SECTION ========================= */}
          
            
                
                  
                       
        
      

      
      

            
        </>
        
    );
};

export default OBGYN;